module.exports = __webpack_public_path__ + "img/gsxhjfw.9d49858c.png";